<template>
  <div class="pg-file-preview-dialog-click">
    <template v-if="showButton">
      <slot :handleClick="handleClick"
        ><Button type="text" @click="handleClick">{{ text }}</Button></slot
      >
    </template>
    <span v-else>-</span>

    <PgFilePreviewDialog
      :visible.sync="visible"
      :value="value"
      :multiple="multiple"
      :v-bind="$attrs"
    ></PgFilePreviewDialog>
  </div>
</template>
<script>
export default {
  inheritAttrs: false,
}
</script>
<script setup>
import { Button } from 'element-ui'
import PgFilePreviewDialog from './file-preview-dialog.vue'
import { computed, ref } from 'vue'

const props = defineProps({
  value: [Array, Object, String],
  multiple: {
    type: Boolean,
    default: true,
  },
  text: {
    type: String,
    default: '查看附件',
  },
})

const visible = ref(false)
const handleClick = () => {
  visible.value = true
}

const showButton = computed(() => {
  return props.multiple ? props.value?.length > 0 : !!props.value
})
</script>
